import { render, staticRenderFns } from "./core-data.vue?vue&type=template&id=47402d19&"
import script from "./core-data.vue?vue&type=script&lang=js&"
export * from "./core-data.vue?vue&type=script&lang=js&"
import style0 from "./core-data.vue?vue&type=style&index=0&id=47402d19&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports